import { Component, OnInit } from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {UserStoreService} from 'src/app/services/user-store.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {

  constructor(
    public userStore: UserStoreService,
    public router: Router,
    public activatedRoute: ActivatedRoute
  ) { }


  ngOnInit(): void {
    this.userStore.user.subscribe(() => {
      this.router.navigateByUrl('/cv-detail/de');
    });
  }

}
